angular = require('angular')
class TagFactory
  @$injector: ['RestfulResource', '$http', '$cookies', '$state', 'config']
  constructor: (RestfulResource, $http, $cookies, $state, config)->    
    url = "#{config.api.url}/tags"    
    actions = {}
    Tag = new RestfulResource("#{url}/:_id", {_id: "@_id"}, actions)     
    Tag.prototype.$install = (app)->
      $http
        url: "#{url}/#{@_id}/devices/apps/"
        method: "POST"
        data: app
      .then (result)->
        return result.data
    Tag.prototype.$reboot = (app)->
      $http
        url: "#{url}/#{@_id}/devices/reboot/"
        method: "PUT"
      .then (result)->
        return result.data
    Tag.prototype.$all = ()->
      $http
        url: "#{url}/all"
        method: "GET"
      .then (result)->
        return result.data      
    Tag.prototype.$findByText = (tagText)->
      $http
        url: "#{url}/#{tagText}"
        method: "GET"
      .then (result)->
        return result.data
    return Tag
module.exports = TagFactory




// WEBPACK FOOTER //
// ./src/component/tag/tag.coffee